"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIsoLocale;

function getIsoLocale(locale) {
  // Transformation from BCP 78 (IETF) to ISO 639‑1
  // Example: "en-US" => "en"
  // Example: "de" => "de"
  return locale.split("-").shift() || locale;
}